export type DayOfWeekName =
  | 'Sunday'
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday';

export type DesktopNotificationType =
  | 'HappinessSurvey'
  | 'JobEnds'
  | 'UpwardFeedback'
  | 'Appraisals';

// Order the admin sees in the type picker.
export const DESKTOP_NOTIFICATION_TYPES: DesktopNotificationType[] = [
  'HappinessSurvey',
  'JobEnds',
  'UpwardFeedback',
  'Appraisals',
];

export const DESKTOP_NOTIFICATION_TYPE_LABELS: Record<DesktopNotificationType, string> = {
  HappinessSurvey: 'Happiness Survey',
  JobEnds: 'Job Ends',
  UpwardFeedback: 'Upward Feedback',
  Appraisals: 'Appraisals',
};

export interface DesktopNotificationScheduleDto {
  dayOfWeek: DayOfWeekName;
  timeOfDay: string;
  snoozeDurationMinutes: number | null;
  isGenerationAnchor: boolean;
}

export interface DesktopNotificationAudienceFilterDto {
  grades: string[];
  geos: string[];
  staffIds: number[];
  excludedStaffIds: number[];
  completionRateMinPercent: number | null;
  completionRateMaxPercent: number | null;
}

export interface DesktopNotificationListItemDto {
  id: number;
  type: DesktopNotificationType;
  name: string;
  enabled: boolean;
  dismissEnabled: boolean;
  schedules: DesktopNotificationScheduleDto[];
  timeZone: string;
  scheduleSummary: string;
  audienceSummary: string;
  updatedAt: string | null;
  rowVersion: string;
}

export interface DesktopNotificationDetailDto {
  id: number;
  type: DesktopNotificationType;
  name: string;
  enabled: boolean;
  dismissEnabled: boolean;
  schedules: DesktopNotificationScheduleDto[];
  timeZone: string;
  scheduleSummary: string;
  header: string;
  body: string;
  audience: DesktopNotificationAudienceFilterDto;
  createdByStaffId: number;
  createdByName: string;
  createdAt: string;
  updatedAt: string | null;
  rowVersion: string;
}

interface DesktopNotificationWriteRequestDto {
  name: string;
  enabled: boolean;
  dismissEnabled: boolean;
  schedules: DesktopNotificationScheduleDto[];
  timeZone: string;
  header: string;
  body: string;
  audience: DesktopNotificationAudienceFilterDto;
}

export interface DesktopNotificationCreateRequestDto extends DesktopNotificationWriteRequestDto {
  type: DesktopNotificationType;
}

// `type` is deliberately absent, mirroring the server contract: the notification kind is locked once
// saved, so the update payload cannot carry it - or silently rewrite it from a stale form.
export interface DesktopNotificationUpdateRequestDto extends DesktopNotificationWriteRequestDto {
  rowVersion: string;
}

export interface DesktopNotificationPlaceholderDto {
  token: string;
  description: string;
}

export interface DesktopNotificationPlaceholdersDto {
  tokens: DesktopNotificationPlaceholderDto[];
}

export interface AudienceStaffOptionDto {
  staffId: number;
  firstName: string;
  lastName: string;
  displayName: string;
  office: string | null;
}
